// extracted by mini-css-extract-plugin
export default {"scene":"heroScene_scene__ZQVNE","canvas":"heroScene_canvas__4fYTY"};